/**
 * rafなどAppの全体管理を行う
 */
import { WebGlApp } from './webGL/WebGlApp';

const OPTIONS = {
  FPS: 60, // FPS制限
}
const FRAME_INTERVAL = 1000 / OPTIONS.FPS; // フレーム間隔

export class AppHandler {
  private WebGlApp: WebGlApp;

  private lastFrameTime: number = 0;

  constructor(
    webglCanvas: HTMLCanvasElement,
  ) {
    // Initialize
    this.WebGlApp = new WebGlApp(webglCanvas);
  }

  /**
   * 初期化
   */
  async initialize(): Promise<void> {
    await this.WebGlApp.initialize();
    // Animation開始
    this.animate();
  }

  private animate = (currentTime: number = 0): void => {
    // FPSを制限するための処理
    const deltaTime = currentTime - this.lastFrameTime;
    if (deltaTime >= FRAME_INTERVAL) {
      this.WebGlApp.render();
      this.lastFrameTime = currentTime;
    }
    requestAnimationFrame(this.animate);
  }

  // Helper ------------------------
}